'use client';

import VideoReactPlayer from '../components/VideoReactPlayer';
import { OPERATOR_REACT_CLIPS } from '@/lib/clipConfigs';

export default function OperatorReactPage() {
  return <VideoReactPlayer mode="operator-react" clips={OPERATOR_REACT_CLIPS} />;
}
